var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodesGreenCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1304_1843",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1304_1843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17178 9.48008L10.0936 5.5583L9.47883 4.94357L6.17178 8.25062L4.50928 6.58812L3.89455 7.20285L6.17178 9.48008ZM7.00064 12.5403C6.23418 12.5403 5.51374 12.3949 4.83933 12.104C4.16491 11.8131 3.57826 11.4183 3.07938 10.9197C2.5805 10.421 2.18555 9.83464 1.89453 9.16052C1.60352 8.48641 1.45801 7.76612 1.45801 6.99966C1.45801 6.2332 1.60345 5.51276 1.89434 4.83835C2.18523 4.16393 2.58 3.57728 3.07865 3.07841C3.57732 2.57952 4.16371 2.18457 4.83783 1.89355C5.51194 1.60254 6.23222 1.45703 6.99868 1.45703C7.76514 1.45703 8.48558 1.60248 9.15999 1.89337C9.83441 2.18425 10.4211 2.57902 10.9199 3.07768C11.4188 3.57634 11.8138 4.16273 12.1048 4.83685C12.3958 5.51096 12.5413 6.23125 12.5413 6.99771C12.5413 7.76417 12.3959 8.4846 12.105 9.15902C11.8141 9.83344 11.4193 10.4201 10.9207 10.919C10.422 11.4178 9.83561 11.8128 9.16149 12.1038C8.48738 12.3948 7.7671 12.5403 7.00064 12.5403Z",
    fill: "#06B217"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodesGreenCircle);
export default __webpack_public_path__ + "static/media/Nodes-green-circle.e329bc73dbd79a04b21fd3a93361c978.svg";
export { ForwardRef as ReactComponent };